/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { EditorModule } from "document-model";
import { lazy } from "react";

/** Document editor module for the "renown/oidc-client" document type */
export const RenownOidcClientEditor: EditorModule = {
  Component: lazy(() => import("./editor.js")),
  documentTypes: ["renown/oidc-client"],
  config: {
    id: "renown-oidc-client-editor",
    name: "Renown OIDC Client Editor",
  },
};
